<h3>{{ 'LOGOUT.LOADING' | translate }}</h3>
